let BASE_URL;
if (process.env.NODE_ENV === "production") {
  BASE_URL = "/api";  // Use Nginx proxy in production
} else {
  BASE_URL = "http://localhost:5000";
}
export { BASE_URL };
